import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  standalone: true,
  imports: [TranslateModule, MatDialogModule],
  selector: 'app-loader-modal',
  templateUrl: './loader-modal.component.html',
  styleUrls: ['./loader-modal.component.scss'],
})
export class LoaderModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public spinnerText = 'Loading...') {}
}
